import {combineReducers} from "redux";
import transferWithAmount from "./amount";
import percentage from "./percentage";
import shareConfig from "./shareConfig";

const transferReducer = combineReducers({
    transferWithAmount,
    percentage,
    shareConfig
});
export default transferReducer;
